export const JA = {
  common: {
    save: '保存',
    delete: '削除',
    cancel: 'キャンセル',
    edit: '編集',
    create: '作成',
    add: '追加',
    apply: '適用',
    confirm: '確認',
    close: '閉じる',
    search: '検索...',
    loading: '読み込み中...',
    processing: '処理中...',
    updating: '更新中です',
    action: 'アクション',
    status: '状態',
    type: 'タイプ',
    erase: '消去',
    csvExport: 'CSV出力',
    filterReset: 'フィルターリセット',
    password: 'パスワード',
    submitting: '送信中...',
    verify: '認証',
    all: '全て',
    enabled: '有効',
    disabled: '無効',
    access: 'アクセス',
    unknown: '不明',
  },
  errors: {
    unexpected: '予期しないエラーが発生しました',
    detail: (detail) => `エラーが発生しました: ${detail}`,
  },
  notFound: {
    title: 'ページが見つかりません',
    description: 'お探しのページは存在しないか、移動した可能性があります。URLをご確認ください。',
    back: 'トップページへ戻る',
  },
  auth: {
    appName: '行動検知AI',
    appSubtitle: '管理コンソール',
    email: 'メールアドレス',
    backToLogin: 'ログイン画面に戻る',
    login: 'ログイン',
    logout: 'ログアウト',
    logoutConfirm: 'ログアウトします',
    exitConfirm: 'アプリケーションを終了します。よろしいですか？',
    enterPassword: 'パスワードを入力してください',
    forgotPassword: 'パスワードをお忘れですか?',
    invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
    accountLocked: 'アカウントは一時的にロックされています',
    tooManyAttempts: '試行回数の制限を超えました。しばらくしてからもう一度お試しください。',
    tryAgainLater: '後でもう一度お試しください',
    sessionTimeout: 'タイムアウトしました。再度ログインしてください',
    lastLogin: '最終ログイン:',
    firstLogin: '初回ログイン',
  },
  otp: {
    invalidCode: 'コードが正しくありません',
    resend: 'コードを再送信',
    resendTimer: (time) => `コードを再送信 (${time})`,
    enterMfaCode: '6桁のMFAコードを入力してください',
    enter6digit: '6桁のコードを入力してください',
    otpCodeWrong: 'OTPコードが違います',
    sessionExpired: 'セッションが期限切れです。最初からやり直してください',
    sessionNotFound: 'セッションが見つかりません。最初からやり直してください',
    mfaFailed: 'MFA認証に失敗しました。しばらくしてから再試行してください',
    setupTitle: 'ワンタイムパスワードの設定',
    verifyTitle: 'ワンタイムパスワード',
    verifyDescription: '認証アプリに表示された6桁のコードを入力してください。',
    setupDescription: '認証アプリでQRコードを読み取り、表示された6桁のコードを入力してください。',
    code: '確認コード',
    mfaPrompt: 'カメラ認証のために、6桁の認証コードを入力してください',
    oneTime: 'ワンタイム',
  },
  password: {
    change: 'パスワード変更',
    resetButton: 'リセット',
    enterResetCode: 'リセットコードを入力してください',
    newPassword: '新しいパスワード',
    newPasswordConfirm: '新しいパスワード(確認)',
    currentPassword: '現在のパスワード',
    changedSuccess: 'パスワードが正常に変更されました',
    changeSignInAgain: 'パスワードの変更が成功しました。もう一度サインインしてください',
    mismatch: 'パスワードが一致しませんでした',
    sameAsOld: '新しいパスワードを古いパスワードと同じにすることはできません。',
    currentIncorrect: '現在のパスワードが正しくありません',
    needBothPasswords: 'パスワードを変更するには古いパスワードと新しいパスワードが必要です',
    newPasswordRequired: '新しいパスワードが必要です',
    ruleViolation: 'パスワード規則に基づいてパスワードを設定してください。',
    resetCodeSentPrefix: '',
    resetCodeSentSuffix: ' に送信したコードと、新しいパスワードを入力してください。',
    changeButton: 'パスワードを変更する',
    forgotTitle: 'パスワードをお忘れですか',
    forgotDescription: '登録済みのメールアドレスにリセットコードを送信します。',
    sendResetCode: 'リセットコードを送信',
    resetTitle: '新しいパスワードを設定',
    resetCode: 'リセットコード',
    resetSubmit: 'パスワードを再設定',
    resetFieldsRequired: 'リセットコードと新しいパスワードを入力してください',
    firstLoginTitle: 'パスワードの変更',
    firstLoginDescription: '初回ログインのため、新しいパスワードを設定してください。',
    rulesTitle: 'パスワードの条件',
    ruleMinLength: (n) => `${n}文字以上`,
    ruleLowercase: '英小文字を含む',
    ruleUppercase: '英大文字を含む',
    ruleNumber: '数字を含む',
    ruleSymbol: '記号を含む',
  },
  account: {
    menu: 'アカウントメニュー',
  },
  validation: {
    required: (field) => `${field} は必須です`,
    invalidId: (hint) => `IDの形式が正しくありません（${hint}）`,
    invalidEmail: 'メールの形式が正しくありません',
    invalidEmailAlt: '無効なメールアドレス',
    confirmCodeWrong: '確認コードが正しくありません。もう一度お試しください。',
    fillAllFields: 'すべての項目を入力してください',
    titleRequired: 'タイトル は必須です',
    redirectUrlRequired: 'リダイレクトURLは必須です',
  },
  user: {
    name: 'ユーザー名',
    nameRequired: 'ユーザー名は必須です',
    email: 'メール',
    role: 'ロール',
    createdAt: '作成日',
    tenantName: 'テナント名',
    tenantUsername: 'テナントユーザー名',
    otpEnabled: 'OTP有無',
    location: '拠点',
    delete: 'ユーザーの削除',
    edit: 'ユーザーの編集',
    createTenantUser: 'テナントユーザー新規作成',
    createLocationUser: '拠点ユーザーの作成',
    confirmDelete: '本当に削除しますか',
    notInGroup: 'ユーザーはグループに属していません',
    selectTag: 'タグを選んでください',
    tenantUserTab: 'テナントユーザー',
    adminRole: '管理者',
    generalRole: '一般',
    userRole: 'ユーザー',
    managementTag: '管理タグ',
    tag: 'タグ',
    userPlaceholder: 'ユーザ名',
    locationUserPlaceholder: '拠点ユーザー名',
  },
  tenant: {
    name: 'テナント名',
    delete: 'テナントの削除',
    edit: 'テナントの編集',
    create: 'テナント新規作成',
    required: 'テナントは必須です',
    groupManagement: 'テナントグループ管理',
    userManagement: 'テナントユーザー管理',
    id: 'テナントID',
  },
  provider: {
    name: '事業者名',
    delete: '事業者の削除',
    edit: '事業者の編集',
    required: '事業者は必須です',
    management: '事業者管理',
    userManagement: '事業者ユーザー管理',
    nameRequired: 'サービスプロバイダーの名前は必須です',
    reOemSelect: '再OEM管理者を選択',
    create: '事業者新規作成',
    userCreate: '事業者ユーザー新規作成',
    type: '事業者タイプ',
    reOemManager: '再OEM管理者',
    userPlaceholder: '事業者ユーザー名',
    // REGEX_SP_ID
    idHint: '英字3文字 + 数字12桁 (例: ABC000000000001)',
  },
  location: {
    name: '場所名',
    delete: '場所を削除',
    edit: '拠点を編集',
    create: '拠点を作成する',
    management: '拠点グループ管理',
    userManagement: '拠点ユーザー管理',
    updateFailed: '場所名の更新に失敗しました',
    noSelected: '選択された場所がありません',
    locationName: '拠点名',
    locationLabel: '拠点',
    // REGEX_LOCATION_ID
    idHint: '英字3文字 + 数字10桁 (例: ABC0000000001)',
  },
  camera: {
    management: 'カメラの管理',
    name: 'カメラ名',
    username: 'カメラUserName',
    password: 'カメラUserPass',
    info: 'カメラ情報',
    aiSettings: 'カメラ AI 設定',
    aiOption: 'AIオプション',
    aiOptionLabel: 'AI オプション',
    plan: 'プラン',
    deviceId: 'デバイスID',
    details: '詳細情報',
    count: 'カメラ台数',
    countAlt: 'カメラの数',
    activated: 'アクティブ化されたカメラ',
    inactive: '非アクティブカメラ',
    countTotal: '合計',
    activatedLabel: '活性化された',
    add: 'カメラを追加する',
    addNew: '新しいカメラを追加する',
    delete: 'カメラを削除',
    deleteAction: 'カメラ削除',
    backToList: 'カメラ一覧に戻る',
    backToPrev: '前のページに戻る',
    notFound: 'カメラが見つかりません',
    dataFetchError: 'カメラデータの取得エラー:',
    dataLoadFailed: 'カメラデータの読み込みに失敗しました',
    startFailed: '起動に失敗しました',
    startSuccess: '起動に成功しました',
    starting: '起動中...',
    updateSuccess: '更新に成功しました!',
    updateFailed: 'カメラの更新に失敗しました',
    cannotUpdateNow: '今は更新できません!',
    confirmActivate: 'このカメラを起動しますか?',
    confirmDelete: 'このカメラを削除してもよろしいですか?',
    cannotDeleteActive: 'カメラはアクティブなため削除できません。画面を更新してください。',
    twoFactorAuth: 'カメラの二段階認証',
    bulkLocationSetting: '拠点一括設定',
    scheduleAddConfirm: 'カメラ追加のスケジュールを設定しますか',
    scheduleDeleteConfirm: 'カメラ削除のスケジュールを設定しますか',
    scheduleImmediate: '(スケジュールを設定しない場合、すぐに再起動します)',
    scheduleTime: '再起動設定時間',
    restartNow: 'すぐに再起動する',
    createRtsp: 'RTSP作成',
    createHls: 'HLS作成',
    hlsAdd: 'HLS変換追加',
    hlsDelete: 'HLS変換削除',
    hlsDeleteConfirm: 'HLS変換を削除します',
    hlsConvertingBeforeVms: 'VMS に追加する前に HLS URL を変換します',
    allFieldsRequired: 'すべてのフィールドは必須です',
    cameraIdExists: '入力されたCamera IDはすでに使われています',
    rtspUrlFormat: "RTSP URL は 'rtsp://xxx' の形式でなければなりません。",
    selectAnalysis: '分析を選択',
    providerId: '事業者ID',
  },
  vms: {
    access: 'VMS にアクセス',
    addToVms: 'VMSに追加',
    removeFromVms: 'VMSから削除',
    adding: 'VMS に追加しています...',
    removing: 'VMS から削除しています...',
    addCameraTitle: 'VMSにカメラを追加する',
    removeCameraTitle: 'VMSからカメラを削除する',
    addSuccess: 'VMSに正常に追加されました',
    removeSuccess: 'VMSから正常に削除されました',
    addFailed: 'VMS への更新に失敗しました!',
    accessFailed: 'VMS へのアクセスに失敗しました',
    removeConfirm: 'VMSから削除します',
    converterRemoveFailed: 'コンバータモジュールからカメラを削除できませんでした',
    conversionStopped: '変換は正常に停止しました',
  },
  notification: {
    title: '通知',
    create: '新しい通知を作成',
    update: '通知を更新',
    none: '通知なし',
    delete: '削除通知',
    markRead: '既読にする',
    markUnread: '未読にする',
    titleField: 'タイトル',
    redirectUrl: 'リダイレクトURL',
    target: '対象',
    today: '今日',
    yesterday: '昨日',
  },
  nav: {
    behaviourAi: '行動検知AI',
    sortAZ: 'A-Zで並べ替え',
    sortZA: 'Z-Aで並べ替え',
    sortBy: (field) => `${field}で並べ替え`,
    filterBy: (field) => `${field}でフィルター`,
    enterHere: 'ここに入力',
  },
  list: {
    search: '検索',
    filter: 'フィルター',
    clearFilters: 'すべてクリア',
    clearColumn: 'クリア',
    total: (count) => `${count}件`,
    noOptions: '選択肢がありません',
    blank: '(なし)',
    dateFrom: '開始日',
    dateTo: '終了日',
    sortAsc: '昇順で並べ替え',
    sortDesc: '降順で並べ替え',
    columnSettings: '列設定',
    visibleColumns: '表示列',
    pageSize: '1ページの表示件数',
    resetColumns: 'デフォルトに戻す',
    dragToReorder: 'ドラッグして並べ替え',
    refresh: '更新',
    lastUpdated: '最終更新',
    justNow: 'たった今',
    minutesAgo: (n) => `${n} 分前`,
    hoursAgo: (n) => `${n} 時間前`,
  },
}
